import { Box, Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { useIsMyMsg, useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgMediaCallCancelledContentProps {
  message: Msg;
}

export const MsgMediaCallCancelledContent = memo(function MsgMediaCallCancelledContent({
  message,
}: MsgMediaCallCancelledContentProps) {
  const { t } = useTranslation();
  const { user } = useUserInfo(message.owner_id);
  const isMe = useIsMyMsg(message);

  return (
    <Box as="span" display="inline">
      {!isMe && (
        <MsgUserText userName={user?.name || ''} userId={user?.user_id} display="inline" />
      )}
      <Text as="span" color="fg.muted" px="0.5" display="inline">
        {isMe ? t('chat.youCancelACall') : t('chat.cancelACall')}
      </Text>
    </Box>
  );
});
